import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import classNames from 'classnames/bind';
import axios from 'axios';
import moment from 'moment';

import styles from './index.module.scss';
import BusinessForm from './forms/Business';
import CleaningForm from './forms/Cleaning';
import GeneralForm from './forms/General';
import OrderForm from './forms/Order';
import ReportForm from './forms/Report';

const cx = classNames.bind(styles);

const QnaView = ({ data: { type, id } }) => {
  const navigate = useNavigate();
  const [qnaData, setQnaData] = useState();

  useEffect(
    () => {
      axios
        .get(`https://pulmuone.console.flyground.co.kr/api/qna/${type}/${id}`)
        .then((res) => {
          if (res.data.success) {
            setQnaData(res.data.data);
            return;
          }

          navigate('/');
        })
        .catch((err) => console.error(err));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const getTitle = (type) => {
    switch (type) {
      case 'general':
        return '제품, 배송, 기타 문의';
      case 'business':
        return '가맹점 사업 신청';
      case 'order':
        return '가맹점 주문 문의';
      case 'cleaning':
        return '냉온수기 세척 신청';
      case 'report':
        return '부정 제보';
      default:
        return 'N/A';
    }
  };

  if (qnaData === undefined) {
    return null;
  }

  return (
    <div className={cx('container')}>
      <div className={cx('limiter')}>
        <ul className={cx('head')}>
          <li>
            <p>
              <span className={cx('label')}>문의유형</span>
              <span className={cx('value')}>{getTitle(type)}</span>
            </p>
          </li>
          <li>
            <p>
              <span className={cx('label')}>작성일자</span>
              <span className={cx('value')}>{moment(qnaData.createdAt).format('YYYY.MM.DD')}</span>
            </p>
          </li>
        </ul>
        {type === 'general' && <GeneralForm data={qnaData} />}
        {type === 'order' && <OrderForm data={qnaData} />}
        {type === 'cleaning' && <CleaningForm data={qnaData} />}
        {type === 'business' && <BusinessForm data={qnaData} />}
        {type === 'report' && <ReportForm data={qnaData} />}
      </div>
    </div>
  );
};

export default QnaView;
